import { useContext, useState } from "react"
import { Tabs, Tab } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import { DashboardContext } from "./DashboardContext"
import { StudentDash } from "./StudentDash"
import { HomeworkView } from "./HomeworkView"
import { ReportView } from "./ReportView"
import "./tabs.css"
export const TabsView = () => {
  const { t, student } = useContext(DashboardContext)
  const [key, setKey] = useState("home")
  return (
    <div className="mt-4">
      <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3 custom-tabs">
        <Tab eventKey="reports" title={t("Reports")}>
          {student && (
            <>
              <StudentDash />
              <ReportView />
            </>
          )}
        </Tab>
        <Tab eventKey="homework" title={t("Homework")}>
          {student && <HomeworkView />}
        </Tab>
      </Tabs>
    </div>
  )
}
